var _circle, _path, _path2, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path3, _path4, _path5, _circle2, _path6, _path7, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 220,
    viewBox: "0 0 221 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 110,
    r: 110,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.5161 56C77.5161 51.5817 81.0978 48 85.5161 48H135.484C139.902 48 143.484 51.5817 143.484 56V143.075C143.484 147.493 139.902 151.075 135.484 151.075H85.5161C81.0978 151.075 77.5161 147.493 77.5161 143.075V56Z",
    fill: "url(#paint0_linear_11005_18061)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7661 56C77.7661 51.7198 81.2359 48.25 85.5161 48.25H135.484C139.764 48.25 143.234 51.7198 143.234 56V143.075C143.234 147.355 139.764 150.825 135.484 150.825H85.5161C81.2359 150.825 77.7661 147.355 77.7661 143.075V56Z",
    stroke: "#D3D6E1",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11005_18061)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.0078,
    y: 59.338,
    width: 32.9834,
    height: 50.5059,
    rx: 4,
    fill: "#EFF1F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.5078,
    y: 59.838,
    width: 31.9834,
    height: 49.5059,
    rx: 3.5,
    stroke: "#80ABF9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 98.6309,
    y: 66.0227,
    width: 23.7376,
    height: 15.4917,
    rx: 1.5,
    fill: "black",
    stroke: "#CACDD7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 106.346,
    y: 91.2606,
    width: 8.30732,
    height: 8.30732,
    rx: 4,
    fill: "white",
    stroke: "#80ABF9",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 99.1616,
    y: 84.0761,
    width: 7.21513,
    height: 2.06146,
    rx: 1,
    fill: "#CACDD7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 99.1616,
    y: 103.66,
    width: 7.21513,
    height: 2.06146,
    rx: 1,
    fill: "#CACDD7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 107.408,
    y: 84.0761,
    width: 7.21513,
    height: 2.06146,
    rx: 1,
    fill: "#CACDD7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 107.408,
    y: 103.66,
    width: 7.21513,
    height: 2.06146,
    rx: 1,
    fill: "#CACDD7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 115.654,
    y: 84.0761,
    width: 7.21513,
    height: 2.06146,
    rx: 1,
    fill: "#CACDD7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 115.654,
    y: 103.66,
    width: 7.21513,
    height: 2.06146,
    rx: 1,
    fill: "#CACDD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.172 158.922L159.488 160.599C158.543 161.539 158.543 163.063 159.488 164.003L170.833 174.711C171.778 175.651 173.309 175.651 174.254 174.711L175.939 173.034C176.883 172.094 176.883 170.57 175.939 169.63L164.593 158.922C163.649 157.982 162.117 157.982 161.172 158.922Z",
    fill: "url(#paint1_linear_11005_18061)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.16 168.383L177.176 168.4C178.803 170.019 178.803 172.645 177.176 174.265L175.491 175.941C173.87 177.555 171.245 177.561 169.616 175.96L158.268 165.25L158.252 165.233C156.625 163.614 156.625 160.988 158.252 159.368L159.937 157.692C161.558 156.078 164.183 156.072 165.812 157.673L177.16 168.383ZM164.594 158.922L175.94 169.63C176.884 170.57 176.884 172.094 175.94 173.034L174.255 174.711C173.31 175.651 171.779 175.651 170.834 174.711L159.488 164.003C158.544 163.063 158.544 161.539 159.488 160.599L161.173 158.922C162.118 157.982 163.649 157.982 164.594 158.922Z",
    fill: "url(#paint2_linear_11005_18061)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 168.028C126.987 168.028 114.623 155.663 114.623 140.455C114.623 125.247 126.987 112.882 142.195 112.882C157.403 112.882 169.768 125.247 169.768 140.455C169.768 155.663 157.403 168.028 142.195 168.028ZM142.195 116.559C129.022 116.559 118.299 127.281 118.299 140.455C118.299 153.629 129.022 164.352 142.195 164.352C155.369 164.352 166.092 153.629 166.092 140.455C166.092 127.281 155.369 116.559 142.195 116.559Z",
    fill: "url(#paint3_linear_11005_18061)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.196,
    cy: 140.455,
    r: 23.9568,
    fill: "url(#paint4_linear_11005_18061)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.019 136.387C124.856 136.387 124.68 136.36 124.517 136.292C123.824 136.005 123.485 135.212 123.756 134.515C126.486 127.642 132.068 122.409 139.076 120.181C139.795 119.949 140.556 120.345 140.773 121.069C141.004 121.794 140.61 122.559 139.89 122.778C133.657 124.759 128.7 129.405 126.269 135.527C126.051 136.059 125.549 136.387 125.006 136.387H125.019Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.305 145.242C122.508 145.242 121.855 144.625 121.855 143.871C121.855 142.582 121.956 141.28 122.174 140.005C122.305 139.251 123.044 138.757 123.827 138.867C124.625 138.99 125.161 139.689 125.031 140.43C124.842 141.554 124.755 142.719 124.755 143.871C124.755 144.625 124.103 145.242 123.305 145.242Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11005_18061",
    x: 82.0078,
    y: 51.338,
    width: 56.9834,
    height: 74.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11005_18061"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11005_18061",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11005_18061",
    x1: 110.5,
    y1: 48,
    x2: 110.5,
    y2: 166.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11005_18061",
    x1: 160.476,
    y1: 159.615,
    x2: 174.88,
    y2: 174.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91B7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80ABF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11005_18061",
    x1: 159.241,
    y1: 158.384,
    x2: 176.105,
    y2: 175.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91B7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80ABF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11005_18061",
    x1: 122.183,
    y1: 119.598,
    x2: 158.894,
    y2: 164.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80ABF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11005_18061",
    x1: 130.236,
    y1: 124.723,
    x2: 163.654,
    y2: 159.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6DAFF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8CDF5"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAsset);
export default __webpack_public_path__ + "static/media/empty_asset.383ed5fc2a52cdf9f50a84e17902d31c.svg";
export { ForwardRef as ReactComponent };